import { ModuleConstants } from '@hrms/common/constant/modules';
import { ComponentsMap } from '@hrms/common/routes/components';
import { ScreenNames } from '@hrms/common/routes/screens';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { generateImage } from '@hrms/common/utils/generateImage';

const reportsBaseRoute = '/reports';

export const reportsSubRoutes = {
  downloads: `downloads`,
  uploads: `uploads`,
};

const getReportsRoutes: ModuleRoutesComponentInterface = () => {
  return [
    {
      id: ModuleConstants.REPORTS,
      route: reportsBaseRoute,
      title: ScreenNames.REPORTS,
      icon: generateImage({
        noScale: true,
        name: 'file',
        alt: 'file',
        className: 'w-4 h-4',
      }),
      component: null,
      children: [
        {
          id: ModuleConstants.UPLOAD_REPORTS_MODULE,
          route: `${reportsBaseRoute}/${reportsSubRoutes.uploads}`,
          title: ScreenNames.UPLOAD_REPORTS_MODULE,
          component: ComponentsMap.UPLOAD_REPORTS,
        },
        {
          id: ModuleConstants.DOWNLOAD_REPORTS_MODULE,
          route: `${reportsBaseRoute}/${reportsSubRoutes.downloads}`,
          title: ScreenNames.DOWNLOAD_REPORTS_MODULE,
          component: ComponentsMap.DOWNLOAD_REPORTS,
        },
      ],
    },
  ];
};

export default getReportsRoutes;
